import { ActionTree } from 'vuex';
import { UserSession } from './types';
import { RootState } from '@/types';
import wsClient from '@/helpers/wsClient'
import store from '@/store'

export const actions: ActionTree<UserSession, RootState> = {
  async fetchSession({ commit }) {
    try {
      const response = await wsClient.authCheck()
      if (response && response.user)
        await store.dispatch('towns/fetchTowns')
      commit('sessionLoaded', response)
    } catch(error) {
      commit('sessionError', error)
    }
  }
}
